$(document).ready(function () {
    $(document).on('click', '.js__add_to_cart', function () {
        const btn = $(this);
        const id = btn.attr('data-id');

        $.post(requests.addToCart, {
            'good_id': id,
            'lang': lang,
        }, function (data) {
            if (data.status == 'success') {
                $('footer').after(data.html);
                $('.js_cart__count').empty().text(data.total_cart);

                toolsGtm.gtmAddToCart(data.gtm_info);

                data.total_cart > 0 ? $('.js__show_checkout').show() : $('.js__show_checkout').hide();
                setTimeout(() => {
                    $('.js_cart-modal').addClass('active');
                    $('body').css('overflow', 'hidden')
                }, 10)
            }

            if (data.status == 'error') {
                console.log(data.error_text)
            }
        })
    })

    $(document).on('click', '.js_card__var-item', function () {
        activeVatiable(this)
        if ($('.js_collection__slider').length) {
            collectionNameHeight()
        } else if ($('.js_goods-list__list').length) {
            window.goodListNameHeight()
        }
    })

    $(document).on('click', '.js_cart-modal__button-continue', function () {
        $('.js_cart-modal').removeClass('active');
        setTimeout(() => {
            $('.js_cart-modal').remove()
        }, 300)
        $('body').removeAttr('style')
    })

    $(document).on('click', '.js_cart-modal__background', function () {
        $('.js_cart-modal').removeClass('active');
        setTimeout(() => {
            $('.js_cart-modal').remove()
        }, 300)
        $('body').removeAttr('style')
    })

    $(document).on('click', '.js_cart-modal__gallery-open', function () {
        $('.js_cart-modal__gallery').addClass('active')
    })

    $(document).on('click', '.js_cart-modal__gallery-close', function () {
        $('.js_cart-modal__gallery').removeClass('active')
    })

    $(document).on('click', '.js_goods__wishlist-add', function () {
        if (!$(this).hasClass('active')) {
            $('.js_goods__wishlist-modal').addClass('active')
            $('.js_goods__wishlist-modal').show(400)
        }
    })

    $(document).on('click', '.js_goods__wishlist-close', function () {
        $('.js_goods__wishlist-modal').hide(400)
        $('.js_goods__wishlist-modal').removeClass('active')
    })

})

function activeVatiable(target) {
    if (!$(target).hasClass('active')) {
        let variant = $(target).data('variant')
        let container = $(target).closest('.js_card')
        container.find('[data-variant]').removeClass('active')
        container.find(`[data-variant="${variant}"]`).addClass('active')
    }
}
